import React, { Component } from 'react';
import moment from 'moment';
import { getPressResume } from '../../../utils/apiMiniWidget';
import { StyledWrapper } from './style';
import PressResumeDate from '../../views/PressResumeDate/PressResumeDate';
import { API_PRESS_DOWNLOAD } from '../../../constants/api';
import { navigateToFile } from '../../../utils/navigate';

class home extends Component {
  constructor(props) {
    super(props);
    this.state = { data: undefined };
  }

  componentDidMount() {
    getPressResume()
      .then(pressResumeData => {
        this.setState({ data: pressResumeData });
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  }

  downloadButton = () => {
    const { data } = this.state;
    if (data && data.length >= 1) {
      navigateToFile(`${API_PRESS_DOWNLOAD}${data[0].clientPath}`);
    }
  };

  render() {
    const { data } = this.state;
    let publishDate;
    let otherTitle;
    if (data && data.length > 0) {
      publishDate = moment(data[0].publishDate);
      otherTitle = data[0].title;
    }
    return (
      <StyledWrapper>
        {data && data.length > 0 && (
          <PressResumeDate
            dayWeek={publishDate.format('ddd')}
            numberWeek={publishDate.format('DD')}
            text={otherTitle}
            onClick={this.downloadButton}
          />
        )}
      </StyledWrapper>
    );
  }
}

export default home;
